import { Box, Flex } from '@chakra-ui/react';
import { Text } from '@kula-ai/components';
import type { DashboardSection } from '../../../types';

// Grounding citations — external link pills so users can verify where the
// research numbers came from. URLs are backend-sanitized (http/https only).
export const SourcesSection = ({ section }: { section: DashboardSection }) => (
  <Flex direction="column" gap="6px">
    {section.text ? (
      <Text variant="small" className="text-secondary-400">
        {section.text}
      </Text>
    ) : null}
    <Flex gap="6px" wrap="wrap">
      {(section.links ?? []).map((l) => (
        <Box
          key={l.url}
          as="a"
          // @ts-expect-error Chakra `as` anchor props
          href={l.url}
          target="_blank"
          rel="noopener noreferrer"
          bg="secondary-50"
          borderRadius="8px"
          px="10px"
          py="4px"
          _hover={{ bg: 'secondary-100' }}
        >
          <Text variant="small" className="text-secondary-700">
            {l.label} ↗
          </Text>
        </Box>
      ))}
    </Flex>
  </Flex>
);
